import { defineComponent, isVue2, h } from 'vue-demi';
import { getOptions, svgIcon, setOptions } from '@yzfe/svgicon';
export { setOptions } from '@yzfe/svgicon';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var VueSvgIcon = defineComponent({
    name: 'VueSvgIcon',
    props: {
        /** icon data */
        data: {
            type: [Object, String],
        },
        width: {
            type: [String, Number],
        },
        height: {
            type: [String, Number],
        },
        scale: {
            type: [String, Number],
        },
        dir: {
            type: String,
        },
        color: {
            type: [String, Array],
        },
        stopColors: {
            type: Array,
        },
        title: {
            type: String,
        },
        fill: {
            type: Boolean,
            default: function () { return !getOptions().isStroke; },
        },
        original: {
            type: Boolean,
            default: function () { return !!getOptions().isOriginalDefault; },
        },
        replace: {
            type: Function,
        },
    },
    emits: {
        click: function (evt) { return evt instanceof MouseEvent; },
    },
    render: function (createElement) {
        var _this = this;
        // @ts-ignore
        var result = svgIcon(this.$props);
        if (isVue2) {
            // https://v3-migration.vuejs.org/breaking-changes/render-function-api.html#vnode-props-format
            return createElement('svg', {
                attrs: __assign({ viewBox: result.box }, this.$attrs),
                staticStyle: __assign({}, result.style),
                staticClass: result.className,
                // @ts-ignore
                on: this.$listeners,
                domProps: {
                    innerHTML: result.path,
                },
            });
        }
        return h('svg', {
            viewBox: result.box,
            style: result.style,
            class: result.className,
            innerHTML: result.path,
            onClick: function (evt) { return _this.$emit('click', evt); },
        });
    },
});
var VueSvgIconPlugin = {
    install: function (app, options) {
        app.component(options.tagName, VueSvgIcon);
        setOptions(options);
    },
};
function createIconComponent(data) {
    var name = (data.name.split('/').pop() || '').replace(/^[\\d_]+/, '');
    var componentName = "SvgIcon".concat(name);
    return defineComponent({
        name: componentName,
        setup: function () {
            return {};
        },
        render: function (createElement) {
            if (isVue2) {
                return createElement(VueSvgIcon, {
                    attrs: this.$attrs,
                    props: __assign({ data: data }, this.$attrs),
                    // @ts-ignore
                    on: this.$listeners,
                });
            }
            return h(VueSvgIcon, __assign(__assign({}, this.$attrs), { data: data }));
        },
    });
}

export { VueSvgIcon, VueSvgIconPlugin, createIconComponent };
//# sourceMappingURL=index.esm.js.map
